

export default class EindPageHelper {

    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        this.context.props.loadLayout("Meld wijzigingen sportorganisatie");
    }

}